/**
 * Friendly error card: a plain-language title with the underlying error
 * detail in smaller muted text. Replaces bare `{error}` divs so reviewers
 * never see a raw API string as the whole page.
 */
export default function ErrorBox(props: {
  title: string;
  detail?: string | null;
}) {
  return (
    <div className="rounded border border-red-200 bg-red-50 p-4 text-sm shadow-sm">
      <div className="font-semibold text-red-900">{props.title}</div>
      {props.detail && (
        <div className="mt-1 break-words font-mono text-xs text-red-800/80">
          {props.detail}
        </div>
      )}
    </div>
  );
}
